<div class="support-widget">
  <button class="support-fab shadow" type="button" (click)="toggle()">
    Help
  </button>

  <div class="support-panel card shadow border-0" *ngIf="opened">
    <div class="card-header d-flex justify-content-between align-items-start gap-2">
      <div>
        <div class="fw-bold">SwipFx Support</div>
        <div class="small text-muted">
          <ng-container *ngIf="isLoggedIn; else publicMode">
            Account-aware support is active
          </ng-container>
          <ng-template #publicMode>
            Public FAQ chat is active
          </ng-template>
        </div>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="clearConversation()">
          New
        </button>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="close()">
          Close
        </button>
      </div>
    </div>

    <div class="card-body support-panel-body">
      <div class="support-messages mb-3">
        <div
          *ngFor="let item of messages; trackBy: trackByIndex"
          class="message-row"
          [ngClass]="{
            'message-user-row': item.sender === 'user',
            'message-bot-row': item.sender !== 'user'
          }">

          <div
            class="message-bubble"
            [ngClass]="{
              'message-user': item.sender === 'user',
              'message-bot': item.sender === 'bot',
              'message-system': item.sender === 'system'
            }">

            <div class="message-label small fw-semibold mb-1 text-uppercase">
              {{ item.label }}
            </div>

            <div class="message-text">{{ item.text }}</div>

            <div class="message-time small mt-1 opacity-75">
              {{ item.at | date:'shortTime' }}
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3" *ngIf="messages.length === 1 && !latestChatResponse">
        <div class="small text-muted mb-2">Popular questions</div>
        <div class="d-flex flex-wrap gap-2">
          <button
            *ngFor="let question of quickTopics"
            class="btn btn-sm btn-outline-primary text-start"
            type="button"
            [disabled]="sending"
            (click)="askQuickQuestion(question)">
            {{ question }}
          </button>
        </div>
      </div>

      <div class="support-actions mb-3" *ngIf="latestChatResponse">
        <div class="small text-muted mb-2">
          Intent: <strong>{{ latestChatResponse.intent }}</strong>
        </div>

        <div class="reactivation-form border rounded p-3 mb-3" *ngIf="shouldShowReactivationForm()">
          <div class="fw-semibold mb-1">Account reactivation request</div>
          <div class="small text-muted mb-3">
            Use the email address registered to the deactivated account. The response does not reveal whether an account exists.
          </div>

          <label class="form-label small">Account email</label>
          <input
            type="email"
            class="form-control form-control-sm mb-2"
            [(ngModel)]="reactivationEmail"
            autocomplete="email"
            placeholder="name@example.com"
            [disabled]="requestingReactivation || reactivationRequested" />

          <label class="form-label small">Reason <span class="text-muted">(optional)</span></label>
          <textarea
            class="form-control form-control-sm mb-2"
            rows="2"
            maxlength="500"
            [(ngModel)]="reactivationReason"
            placeholder="Briefly explain why you want the account restored"
            [disabled]="requestingReactivation || reactivationRequested"></textarea>

          <button
            class="btn btn-primary btn-sm w-100"
            type="button"
            [disabled]="requestingReactivation || reactivationRequested || !reactivationEmail.trim()"
            (click)="submitReactivationRequest()">
            {{ requestingReactivation ? 'Sending Verification Link...' : (reactivationRequested ? 'Verification Link Requested' : 'Send Verification Link') }}
          </button>

          <div class="small text-muted mt-2">
            Never enter a password, PIN, authenticator code, or recovery code here.
          </div>
        </div>

        <div class="d-grid gap-2">
          <a
            *ngIf="hasSuggestedRoute()"
            class="btn btn-primary btn-sm"
            [routerLink]="latestChatResponse.suggestedActionRoute"
            (click)="close()">
            {{ latestChatResponse.suggestedActionLabel || 'Continue' }}
          </a>

          <button
            *ngIf="canCreateTicket()"
            class="btn btn-warning btn-sm"
            type="button"
            [disabled]="creatingTicket"
            (click)="createTicketFromLatestChat()">
            {{ creatingTicket ? 'Creating Ticket...' : 'Create Ticket From This Chat' }}
          </button>

          <a
            *ngIf="isLoggedIn"
            routerLink="/support/tickets"
            class="btn btn-outline-secondary btn-sm"
            (click)="close()">
            View My Tickets
          </a>

          <a
            routerLink="/support"
            class="btn btn-outline-primary btn-sm"
            (click)="close()">
            Open Help Center
          </a>
        </div>
      </div>

      <div class="support-composer">
        <div class="input-group">
          <input
            [(ngModel)]="input"
            (keyup.enter)="send()"
            class="form-control"
            placeholder="Ask about payments, deposits, Instant or Flexible rates, accounts, or KYC..."
            [disabled]="sending" />

          <button
            class="btn btn-primary"
            type="button"
            [disabled]="sending || !input.trim()"
            (click)="send()">
            {{ sending ? 'Sending...' : 'Send' }}
          </button>
        </div>

        <div class="small text-muted mt-2" *ngIf="!isLoggedIn">
          Account records require sign-in. Deactivated users can request reactivation here without signing in.
        </div>
      </div>
    </div>
  </div>
</div>